import { DeleteProgressSession } from '@store/reducers/accountReducer';
import {
    saveTaskProgressSession,
    loadTaskProgressSession,
    clearTaskProgressSession,
} from './taskProgressStorage';

const STORAGE_KEY = 'icdl_delete_progress_session_v1';

export const saveDeleteProgressSession = (session: DeleteProgressSession): void =>
    saveTaskProgressSession(STORAGE_KEY, session);

export const loadDeleteProgressSession = (): DeleteProgressSession | null =>
    loadTaskProgressSession(STORAGE_KEY) as DeleteProgressSession | null;

export const clearDeleteProgressSession = (): void => clearTaskProgressSession(STORAGE_KEY);
